import Axios from 'axios';
import Qs from 'qs';

export default {

  // 敏感词分页列表
  listPage(
    word,
    status,
    page,
    limit
  ) {
    return Axios.get('/base/api/admin/sensitive', {
      params: {
        word,
        status,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加敏感词
  add(
    word
  ) {
    return Axios.post('/base/api/admin/sensitive', {
      word
    });
  },

  // 编辑敏感词
  edit(
    id,
    word
  ) {
    return Axios.patch(`/base/api/admin/sensitive/${id}`, {
      word
    });
  },

  // 敏感词启用
  enable(
    id
  ) {
    return Axios.post(`/base/api/admin/sensitive/enable/${id}`);
  },

  // 敏感词禁用
  disable(
    id
  ) {
    return Axios.post(`/base/api/admin/sensitive/disable/${id}`);
  },

  // 删除敏感词
  del(
    ids
  ) {
    return Axios.delete('/base/api/admin/sensitive', {
      data: {
        ids
      }
    });
  },

  // 敏感词信息
  info(
    id
  ) {
    return Axios.get(`/base/api/admin/sensitive/${id}`);
  },

}